export default __webpack_public_path__ + "static/media/V680_RoHS.739961f7.pdf";